import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
import { Helmet } from 'react-helmet';


const Blog21 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_21;

    const {title, p} = InfoContent.Blog_21.one;
    const {title2, p2} = InfoContent.Blog_21.two;
    const {title3, p3} = InfoContent.Blog_21.three;
    const {title4, p4} = InfoContent.Blog_21.four;
    const {title5, p5} = InfoContent.Blog_21.five;
    const {title6, p6} = InfoContent.Blog_21.six;
    const {title7, p7} = InfoContent.Blog_21.seven;
    const {title8, p8} = InfoContent.Blog_21.eight;
    const {Ctitle, Cp} = InfoContent.Blog_21.conclusion;
    

    const {liss1} = ListContent.Blog_21.L1;
    const {liss2} = ListContent.Blog_21.L2;
    const {liss3} = ListContent.Blog_21.L3;
    const {liss4} = ListContent.Blog_21.L4;
  return (
    <>

        <Helmet>
            <title>
              Best Gynecologist Hospital in Chembur | Expert Care 2026
            </title>

            <meta
                name="description"
                content="Gynecologist hospital in Chembur offering expert fertility & maternity care. Consult top specialists and start your journey today. Visit now."
            />

            <meta
                name="keywords"
                content="gynecologist hospital in chembur, fertility clinic hospital near me, best infertility specialist in mumbai, ivf centre in mumbai, maternity hospital chembur, infertility clinic near me, ivf hospital near me"
            />

            <link
                rel="canonical"
                href="https://www.acmefertility.com/21/BlogDetails"
            />
           
            <script type="application/ld+json">
            {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
                {
                "@type": "Article",
                "headline": "7 Powerful Reasons to Choose a Gynecologist Hospital in Chembur for Safe Motherhood (2026)",
                "author": {
                    "@type": "Organization",
                    "name": "Acme Fertility"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Acme Fertility"
                },
                "datePublished": "2026-01-01",
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://www.acmefertility.com/"
                }
                },
                {
                "@type": "Organization",
                "name": "Acme Fertility",
                "url": "https://www.acmefertility.com/",
                "sameAs": []
                },
                {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Which is the best gynecologist hospital in Chembur?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The best hospital offers experienced doctors, advanced technology, and high success rates in fertility and maternity care."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "When should I visit a fertility clinic?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Visit after one year of trying or earlier if age is above 35 or medical issues exist."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Is IVF safe in Mumbai?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, IVF is safe when performed by experienced specialists in certified clinics."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "How to find a fertility clinic near me?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Search online, check reviews, and choose clinics with high success rates and expert doctors."
                    }
                    }
                ]
                }
            ]
            })}
        </script>
        </Helmet>

        

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={title2} p={p2} />
                    <Info title={title3} p={p3} />
                    <Info title={title4} p={p4} />
                    <Info title={title5} p={p5} />
                    <Info title={Ctitle} p={Cp} />
                    <Info title={title6} p={p6} />
                    <Info title={title7} p={p7} />
                  
                     

                    
             </div>

                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default Blog21